import { ReduceStore } from 'flux/utils';
import Dispatcher from '../dispatcher';
import { actions } from '../constants/fitting_station_finder/actions';
import { isEqual } from '../../../lib/utilities';


class FittingStationStoreClass extends ReduceStore {
    getInitialState() {
        return {
            loading: false,
            loadingPrices: false,
            fetchingFailed: false,
            stations: [],
            sorting: 'distance',
            detailModeStation: null,
            showChangePostcodeForm: false,
            showAllCosts: [],
            quantity: null,
        };
    }

    reduce(state, { source, action }) {
        if (source === 'STATION_LIST_ACTION') {
            switch (action.type) {
                case actions.SHOW_DETAILS:
                    if (state.detailModeStation !== action.payload) {
                        state.detailModeStation = action.payload;
                        this.__emitChange();
                    }
                    break;

                case actions.SHOW_LIST:
                    if (state.detailModeStation !== null) {
                        state.detailModeStation = null;
                        this.__emitChange();
                    }
                    break;

                case actions.HOVER_STATION:
                    if (state.hoveredStation !== action.payload) {
                        state.hoveredStation = action.payload;
                        this.__emitChange();
                    }
                    break;

                case actions.HOVER_END_STATION:
                    if (state.hoveredStation !== null) {
                        state.hoveredStation = null;
                        this.__emitChange();
                    }
                    break;

                case actions.SORT_STATIONS:
                    if (state.sorting !== action.payload) {
                        state.sorting = action.payload;
                        state.stations = this.sortStations(state, state.stations);
                        this.__emitChange();
                    }
                    break;

                case actions.FETCH_STATIONS:
                    if (state.loading === false) {
                        state.loading = true;
                        state.loadingPrices = true;
                        state.fetchingFailed = false;
                        this.__emitChange();
                    }
                    break;

                case actions.STATIONS_FETCHED:
                    state.loading = false;
                    state.loadingPrices = !action.payload.pricesLoaded;
                    if (!isEqual(state.stations, action.payload.stations)) {
                        state.stations = this.sortStations(state, action.payload.stations);
                        this.formatEtaDates(state.stations);
                    }
                    this.__emitChange();
                    break;

                case actions.FETCHING_STATIONS_FAILED:
                    state.stations = [];
                    state.loading = false;
                    state.loadingPrices = false;
                    state.fetchingFailed = true;
                    this.__emitChange();
                    break;

                case actions.SHOW_ALL_COSTS:
                    if (state.showAllCosts.indexOf(action.payload) === -1) {
                        state.showAllCosts.push(action.payload);
                        this.__emitChange();
                    }
                    break;

                case actions.HIDE_ALL_COSTS: {
                    let showAllCostsIndex = state.showAllCosts.indexOf(action.payload);
                    if (showAllCostsIndex !== -1) {
                        state.showAllCosts.splice(showAllCostsIndex, 1);
                        this.__emitChange();
                    }
                }
                    break;

                case actions.SHOW_CHANGE_POSTCODE_FORM:
                    if (!state.showChangePostcodeForm) {
                        state.showChangePostcodeForm = true;
                        this.__emitChange();
                    }
                    break;

                case actions.HIDE_CHANGE_POSTCODE_FORM:
                    if (state.showChangePostcodeForm) {
                        state.showChangePostcodeForm = false;
                        this.__emitChange();
                    }
                    break;
                case actions.CLEAR_STATION:
                    state = this.getInitialState();
                    this.__emitChange();
                    break;
                case actions.SET_QUANTITY:
                    if (state.quantity !== action.payload) {
                        state.quantity = action.payload;
                        this.__emitChange();
                    }
                    break;
            }
        }

        return state;
    }

    sortStations(state, stations) {
        const key = state.sorting;
        const sortedStations = stations.concat()
            .sort((a, b) => (a['sort'][key] > b['sort'][key]) ? 1 :
                ((b['sort'][key] > a['sort'][key]) ? -1 : 0));

        const sortActiveStations = sortedStations.sort((a,b) => a.deactivatedInFsf - b.deactivatedInFsf);
        return [...sortActiveStations];
    }

    parseApiDate(stringDate) {
        return new Date(Date.UTC(
            parseInt(stringDate.slice(0, 4), 10),
            parseInt(stringDate.slice(5, 7), 10) - 1,
            parseInt(stringDate.slice(8, 10), 10),
            parseInt(stringDate.slice(11, 13), 10),
            parseInt(stringDate.slice(14, 16), 10),
            parseInt(stringDate.slice(18, 20), 10)
        ));
    }

    formatEtaDates(stations) {
        stations.forEach(function (station, index) {

            if (station.etaFrom !== null) {
                station.etaFrom = FittingStationStore.parseApiDate(station.etaFrom);
            }

            if (station.etaTo !== null) {
                station.etaTo = FittingStationStore.parseApiDate(station.etaTo);
            }

            stations[index] = station;
        });
    }
}

const FittingStationStore = new FittingStationStoreClass(Dispatcher);
export { FittingStationStore };
export default FittingStationStore;
